import React from "react";
import { motion } from "framer-motion";
import "./About.css";
import { FaAward, FaUsers, FaFolder } from "react-icons/fa";
import me from "../../assets/me.jpg";
import Reveal from "../motion/Reveal";
import AboutAsk from "./AboutAsk";
import { staggerContainer, staggerItem } from "../motion/variants";

const About = () => {
  return (
    <Reveal as="section" id="about">
      <h5 className="title">Get To Know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <img src={me} alt="Wafa Ben Miloud" className="about__me-image" />
        </div>
        <div className="about__content">

          <motion.div
            className="about__cards"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: "some" }}
            variants={staggerContainer}
          >
            <motion.article className="about__card" variants={staggerItem}>
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small>3+ Years</small>
            </motion.article>

            <motion.article className="about__card" variants={staggerItem}>
              <FaUsers className="about__icon" />
              <h5>Technologies</h5>
              <small>15+ Tools & Frameworks</small>
            </motion.article>

            <motion.article className="about__card" variants={staggerItem}>
              <FaFolder className="about__icon" />
              <h5>Projects</h5>
              <small>17+ Delivered</small>
            </motion.article>
          </motion.div>
          <AboutAsk />
        </div>
      </div>
    </Reveal>
  );
};

export default About;
